import { __makeTemplateObject } from "tslib";
import styled from 'styled-components';
export var Root = styled.ul.withConfig({
  displayName: "ui-kit-Root",
  componentId: "ui-kit-1ruj0xl"
})(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  position: relative;\n  margin: 0;\n  padding: 0;\n  list-style: none;\n  \n  &.padded {\n    padding-top: 8px;\n    padding-bottom: 8px;\n  }\n"], ["\n  position: relative;\n  margin: 0;\n  padding: 0;\n  list-style: none;\n  \n  &.padded {\n    padding-top: 8px;\n    padding-bottom: 8px;\n  }\n"])));
var templateObject_1;